"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breadcrumbs = exports.routes = exports.routeFor = void 0;
exports.routeFor = {
    home: () => `/`,
    logout: () => '/auth/logout',
    privacy: () => `/privacy`,
    terms: () => `/terms`,
    imprint: () => `/imprint`,
    noauth: () => `/noauth`,
    notifications: () => `/notifications`,
};
exports.routes = Object.keys(exports.routeFor).reduce((prev, curr) => {
    prev[curr] = exports.routeFor[curr]();
    return prev;
}, {});
exports.breadcrumbs = [
    {
        path: exports.routes.home,
        parent: undefined,
        title: 'Home',
    },
    {
        path: exports.routes.notifications,
        parent: exports.routes.home,
        title: 'Notifications',
    },
    {
        path: exports.routes.privacy,
        parent: exports.routes.home,
        title: 'Data privacy',
    },
    {
        path: exports.routes.terms,
        parent: exports.routes.home,
        title: 'Terms and conditions',
    },
    {
        path: exports.routes.imprint,
        parent: exports.routes.home,
        title: 'Imprint',
    },
];
